import { Link, Text, TextProps } from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";

export const MarkdownText = ({ children, ...props }: { children: string } & TextProps) => (
  <ReactMarkdown
    components={{
      a: ({ href, children }) => {
        const isExternal = href?.startsWith("http");
        return (
          <Link
            href={href ?? "#"}
            color="blue.500"
            textDecoration="underline"
            fontWeight="500"
            target={isExternal ? "_blank" : ""}
            rel={isExternal ? "noopener noreferrer" : ""}
          >
            {children}
          </Link>
        );
      },
      p: ({ children }) => (
        <Text fontWeight="500" color="fg.muted" {...props}>
          {children}
        </Text>
      ),
    }}
  >
    {children}
  </ReactMarkdown>
);
